import { getAppConfig } from 'services/configService';

export const getVersionedCacheKey = (prefix: string): string => {
    const config = getAppConfig();
    return `${prefix}_${config.CacheVersionIdentifier}`;
};
